import React from 'react';
import { Order } from '../../../../app/services/api/orderManagementClient';
import WeightedPointsMap from '../components/WeightedPointsMap';

interface OrdersByMarketProps {
  orders: Order[];
}

const OrdersByMarket = ({ orders }: OrdersByMarketProps) => {
  const heatmapData: { location: { lat: number, lng: number }, weight: number }[] = [
  ];

  const marketCounts: { [market: string]: number } = {};
  orders.forEach(order => {
    marketCounts[order.supplierName] = (marketCounts[order.supplierName] || 0) + 1;
  });

  return (
    <div>
      {Object.entries(marketCounts).map(([market, count]) => (
        <div key={market}>{market}: {count}</div>
      ))}
      <WeightedPointsMap points={heatmapData} />
    </div>
  );
};

export default OrdersByMarket;
